"use strict";
exports.__esModule = true;
var regexSchema = {
    $id: 'muninn.regexSchema',
    oneOf: [
        {
            type: 'object',
            properties: {
                pattern: {
                    type: 'string'
                },
                flags: {
                    type: 'string'
                }
            }
        },
        {
            type: 'string'
        }
    ]
};
exports["default"] = regexSchema;
